import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, DatePicker, Select, TextInput } from 'components/Form'
import { createApiRecord, updateApiRecord, uploadApiExtraDocuments } from 'services/InboundDeliveryService'
import { useDispatch, useSelector } from 'react-redux'
import { getRecord, orderDefaultData } from './store/dataSlice'
import reducer from './store'
import { injectReducer } from 'store'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { Success } from 'utils/alerts'
import { SimpleTable, Tabs, Upload } from 'components/Ui'
import { clone, remove } from 'lodash'
import dayjs from 'dayjs'
import { AiOutlineClose, AiOutlinePlus } from 'react-icons/ai'
import { priorityOptions } from 'utils/options'
injectReducer('inboundDelivery', reducer)

const validationSchema = Yup.object().shape({
    company: Yup.string().required('company field is required'),
    customer: Yup.string().required('customer field is required'),
    // order_type: Yup.string().required('order type field is required'),
    warehouse_id: Yup.string().required('warehouse field is required'),
    doc_no: Yup.string().required('order no. field is required'),
})

const Create = () => {
    const { id } = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { companyData, customersData, warehouseData, orderTypeData, productData } = useSelector(state => state.listData)
    const { view, record, loading } = useSelector(state => state.inboundDelivery.data)

    useEffect(() => {
        if (id) {
            fetchData(id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    const fetchData = id => {
        dispatch(getRecord(id))
    }

    const handleDiscard = () => navigate('/maestro/inbound-delivery')

    const uploadFile = (id, data) => {
        if (data?.file1 || data?.file2 || data?.file3 || data?.file4 || data?.file5) {
            uploadApiExtraDocuments(id, {
                file1: data?.file1 || '',
                file2: data?.file2 || '',
                file3: data?.file3 || '',
                file4: data?.file4 || '',
                file5: data?.file5 || '',
            })
                .then(() => {})
                .catch(error => console.log('Error: ', error))
        }
    }

    const handleSubmit = data => {
        if (id) {
            // const datas = { ...data, customerId: data?.customer, docNo: data?.doc_no }
            const datas = {
                warehouse_id: data?.warehouse_id || null,
                docNo: data?.doc_no || null,
                docType: data?.asn_type || null,
                asn_reference_a: data?.asn_reference_a || null,
                asn_reference_b: data?.asn_reference_b || null,
                asn_reference_c: data?.asn_reference_c || null,
                asn_reference_d: data?.asn_reference_d || null,
                asn_creation_time: data?.asn_creation_time || null,
                expected_arrive_time1: data?.expected_arrive_time1 || null,
                expected_arrive_time2: data?.expected_arrive_time2 || null,
                actual_delivery_date: data?.actual_delivery_date || null,
                receivedTime: data?.receivedTime || null,
                supplier_id: data?.supplier_id || null,
                supplier_name: data?.supplier_name || null,
                carrier_id: data?.carrier_id || null,
                carrier_name: data?.carrier_name || null,
                country_of_destination: data?.country_of_destination || null,
                country_of_origin: data?.country_of_origin || null,
                follow_up: data?.follow_up || null,
                place_of_discharge: data?.place_of_discharge || null,
                place_of_loading: data?.place_of_loading || null,
                place_of_delivery: data?.place_of_delivery || null,
                priority: data?.priority || null,
                hedi01: data?.hedi01 || null,
                hedi02: data?.hedi02 || null,
                hedi03: data?.hedi03 || null,
                hedi04: data?.hedi04 || null,
                hedi05: data?.hedi05 || null,
                hedi06: data?.hedi06 || null,
                hedi07: data?.hedi07 || null,
                hedi08: data?.hedi08 || null,
                hedi09: data?.hedi09 || null,
                hedi10: data?.hedi10 || null,
                user_define1: data?.user_define1 || null,
                user_define2: data?.user_define2 || null,
                user_define3: data?.user_define3 || null,
                user_define4: data?.user_define4 || null,
                user_define5: data?.user_define5 || null,
                user_define6: data?.user_define6 || null,
                notes: data?.notes || null,
                processed_to_wms: data?.processed_to_wms || null,
                processing_batch_id: data?.processing_batch_id || null,
                processed_date_time: data?.processed_date_time || null,
                import_batch_id: data?.import_batch_id || null,
                processing_status: data?.processing_status || null,
                source_system: data?.source_system || null,
                destination: data?.destination || null,
                data_source: data?.data_source || null,
                created_at: data?.created_at || null,
                updated_at: data?.updated_at || null,
                // is_exported: data?.is_exported || null,
                // is_deleted: data?.is_deleted || null,
                // is_archive: data?.is_archive || null,
                company: data?.company || null,
                customerId: data?.customer || null,
                created_by: data?.created_by || null,
                updated_by: data?.updated_by || null,
                order_details:
                    data?.order_details?.map(item => {
                        return {
                            lineNo: item?.['Line Seq'] || null,
                            sku: item?.['Sku'] || null,
                            expectedQty: item?.['Ordered Qty'] || 0,
                        }
                    }) || [],
            }
            // delete datas?.customer
            // delete datas?.doc_no
            updateApiRecord(id, datas)
                .then(resp => {
                    Success('Updated Successfully!')
                    uploadFile(resp.data.id, data)
                    handleDiscard()
                })
                .catch(error => console.log('Error: ', error))

            // updateApiOrderRecord(id, {
            //     ...details,
            //     sku: data?.sku,
            //     qty_ordered: data?.qty_ordered,
            //     line_no: data?.line_no,
            //     sales_order: id,
            // })
            //     .then(() => {
            //         Success('Details Updated Successfully!')
            //         handleDiscard()
            //     })
            //     .catch(error => console.log('Error: ', error))
        } else {
            createApiRecord({ ...data, order_time: dayjs(new Date()).format('YYYY-MM-DDTHH:mm') })
                .then(response => {
                    // createApiOrderRecord({ sku: data?.sku, qty_ordered: data?.qty_ordered, line_no: data?.line_no })
                    //     .then(() => {
                    Success('Created Successfully!')
                    handleDiscard()
                    // })
                    // .catch(error => console.log('Error: ', error))
                })
                .catch(error => console.log('Error: ', error))
        }
    }

    if (loading) {
        return null
    }

    return (
        <>
            <div className="flex flex-col gap-1 mb-3 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">
                    {id ? 'Update Inbound Delivery' : 'Add New Inbound Delivery'}
                </h2>
            </div>
            <div className="flex flex-col items-center">
                <div className="w-full bg-white border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                    <div className="px-5 py-3 border-b border-stroke dark:border-strokedark">
                        <h3 className="font-medium text-black dark:text-white">
                            {id
                                ? 'Change delivery and product details to update a inbound delivery'
                                : 'Enter delivery and product details to create a new inbound delivery'}
                        </h3>
                    </div>
                    <div className="flex flex-col gap-3 p-6">
                        <Formik
                            initialValues={id ? record : view}
                            validationSchema={validationSchema}
                            onSubmit={values => {
                                handleSubmit(values)
                            }}
                        >
                            {({ values, setFieldValue, touched, errors }) => (
                                <Form>
                                    <Tabs.Group version={1}>
                                        <Tabs.List>
                                            <Tabs>Order Header</Tabs>
                                            <Tabs>Order Details</Tabs>
                                            {id && <Tabs>Additional Documents</Tabs>}
                                        </Tabs.List>
                                        <Tabs.Panels className="mt-4">
                                            <Tabs.Panel>
                                                <div className="grid grid-cols-1 gap-x-4 gap-y-4 md:grid-cols-6">
                                                    <Field name="company">
                                                        {({ field, form }) => (
                                                            <Select
                                                                id="company"
                                                                name="company"
                                                                label="Company"
                                                                placeholder="Company"
                                                                className="md:col-span-2"
                                                                value={values?.company}
                                                                options={companyData}
                                                                onChange={e => {
                                                                    form.setFieldValue(field.name, e.target.value)
                                                                    form.setFieldValue('customer', '')
                                                                    form.setFieldValue('warehouse_id', '')
                                                                }}
                                                                error={touched.company && errors.company}
                                                                message={errors.company}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="customer">
                                                        {({ field, form }) => (
                                                            <Select
                                                                options={customersData?.filter(
                                                                    item =>
                                                                        item?.company?.id?.toString() ===
                                                                        values?.company?.toString()
                                                                )}
                                                                label="Customer"
                                                                size="sm"
                                                                placeholder="Select"
                                                                name="customer"
                                                                className="md:col-span-2"
                                                                error={errors.customer && touched.customer}
                                                                message={errors.customer}
                                                                value={values?.customer}
                                                                onChange={e => {
                                                                    form.setFieldValue(field.name, e.target.value)
                                                                    form.setFieldValue('warehouse_id', '')
                                                                }}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="warehouse_id">
                                                        {({ field, form }) => (
                                                            <Select
                                                                options={warehouseData
                                                                    ?.filter(
                                                                        item =>
                                                                            item?.company?.toString() ===
                                                                            values?.company?.toString()
                                                                    )
                                                                    ?.filter(
                                                                        item =>
                                                                            item?.customer?.toString() ===
                                                                            values?.customer?.toString()
                                                                    )}
                                                                label="Warehouse"
                                                                size="sm"
                                                                placeholder="Select"
                                                                className="md:col-span-2"
                                                                name="warehouse_id"
                                                                error={errors.warehouse_id && touched.warehouse_id}
                                                                message={errors.warehouse_id}
                                                                value={values?.warehouse_id}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="doc_no">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Order No"
                                                                name="doc_no"
                                                                error={errors.doc_no && touched.doc_no}
                                                                message={errors.doc_no}
                                                                value={values?.doc_no}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    {/* <Field name="order_type">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Order Type"
                                                                name="order_type"
                                                                error={errors.order_type && touched.order_type}
                                                                message={errors.order_type}
                                                                value={values?.order_type}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field> */}
                                                    <Field name="asn_type">
                                                        {({ field, form }) => (
                                                            <Select
                                                                options={orderTypeData
                                                                    ?.filter(
                                                                        item =>
                                                                            item?.company?.toString() ===
                                                                            values?.company?.toString()
                                                                    )
                                                                    ?.filter(
                                                                        item =>
                                                                            item?.customer?.toString() ===
                                                                            values?.customer?.toString()
                                                                    )}
                                                                label="Order Type"
                                                                size="sm"
                                                                placeholder="Select"
                                                                className="md:col-span-2"
                                                                name="asn_type"
                                                                error={errors.asn_type && touched.asn_type}
                                                                message={errors.asn_type}
                                                                value={values?.asn_type}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="asn_reference_a">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Reference 1"
                                                                name="asn_reference_a"
                                                                error={errors.asn_reference_a && touched.asn_reference_a}
                                                                message={errors.asn_reference_a}
                                                                value={values?.asn_reference_a}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="asn_reference_b">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Reference 2"
                                                                name="asn_reference_b"
                                                                error={errors.asn_reference_b && touched.asn_reference_b}
                                                                message={errors.asn_reference_b}
                                                                value={values?.asn_reference_b}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="asn_reference_c">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Reference 3"
                                                                name="asn_reference_c"
                                                                error={errors.asn_reference_c && touched.asn_reference_c}
                                                                message={errors.asn_reference_c}
                                                                value={values?.asn_reference_c}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="priority">
                                                        {({ field, form }) => (
                                                            <Select
                                                                options={priorityOptions}
                                                                label="Priority"
                                                                size="sm"
                                                                placeholder="Select"
                                                                className="md:col-span-2"
                                                                name="priority"
                                                                error={errors.priority && touched.priority}
                                                                message={errors.priority}
                                                                value={values?.priority}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="expected_arrive_time1">
                                                        {({ field, form }) => (
                                                            <DatePicker
                                                                className="md:col-span-2"
                                                                label="Shipment Date"
                                                                name="expected_arrive_time1"
                                                                error={
                                                                    errors.expected_arrive_time1 && touched.expected_arrive_time1
                                                                }
                                                                message={errors.expected_arrive_time1}
                                                                value={
                                                                    values?.expected_arrive_time1
                                                                        ? dayjs(values?.expected_arrive_time1).format(
                                                                              'YYYY-MM-DD'
                                                                          )
                                                                        : ''
                                                                }
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                </div>
                                            </Tabs.Panel>
                                            <Tabs.Panel>
                                                <div className="grid grid-cols-1 gap-x-4 gap-y-4">
                                                    {values?.order_details?.length ? (
                                                        <SimpleTable>
                                                            <thead>
                                                                <SimpleTable.TR>
                                                                    <SimpleTable.TH>Sequence</SimpleTable.TH>
                                                                    <SimpleTable.TH>Product</SimpleTable.TH>
                                                                    {/* <SimpleTable.TH>Description</SimpleTable.TH> */}
                                                                    <SimpleTable.TH>Quantity</SimpleTable.TH>
                                                                    <SimpleTable.TH>Action</SimpleTable.TH>
                                                                </SimpleTable.TR>
                                                            </thead>
                                                            <tbody>
                                                                {(values?.order_details ?? []).map((item, index) => (
                                                                    <SimpleTable.TR key={`order-${index}`}>
                                                                        <SimpleTable.TD>{item?.['Line Seq']}</SimpleTable.TD>
                                                                        <SimpleTable.TD>
                                                                            <Field name="Sku">
                                                                                {({ field, form }) => (
                                                                                    <Select
                                                                                        id="Sku"
                                                                                        name="Sku"
                                                                                        // label="Product"
                                                                                        placeholder="Product"
                                                                                        className="md:col-span-2"
                                                                                        value={item?.Sku}
                                                                                        options={productData
                                                                                            ?.filter(
                                                                                                item =>
                                                                                                    item?.company?.toString() ===
                                                                                                    values?.company?.toString()
                                                                                            )
                                                                                            ?.filter(
                                                                                                item =>
                                                                                                    item?.customer?.toString() ===
                                                                                                    values?.customer?.toString()
                                                                                            )}
                                                                                        onChange={e => {
                                                                                            form.setFieldValue(
                                                                                                `order_details[${index}].${field.name}`,
                                                                                                e.target.value
                                                                                            )
                                                                                            form.setFieldValue(
                                                                                                `order_details[${index}].line_no`,
                                                                                                index + 1
                                                                                            )
                                                                                            // form.setFieldValue(
                                                                                            //     `order_details[${index}].notes`,
                                                                                            //     productData?.find(
                                                                                            //         item =>
                                                                                            //             item?.Sku ===
                                                                                            //             e.target.value
                                                                                            //     )?.sku_descr1
                                                                                            // )
                                                                                        }}
                                                                                        error={touched.Sku && errors.Sku}
                                                                                        message={errors.Sku}
                                                                                    />
                                                                                )}
                                                                            </Field>
                                                                        </SimpleTable.TD>
                                                                        {/* <SimpleTable.TD>{item?.notes}</SimpleTable.TD> */}
                                                                        <SimpleTable.TD>
                                                                            <Field name="Ordered Qty">
                                                                                {({ field, form }) => (
                                                                                    <TextInput
                                                                                        type="text"
                                                                                        className="md:col-span-2"
                                                                                        placeholder="Quantity"
                                                                                        name="Ordered Qty"
                                                                                        error={
                                                                                            errors.qty_ordered &&
                                                                                            touched.qty_ordered
                                                                                        }
                                                                                        message={errors.qty_ordered}
                                                                                        value={
                                                                                            item?.['Ordered Qty']
                                                                                                ? parseInt(item?.['Ordered Qty'])
                                                                                                : ''
                                                                                        }
                                                                                        onChange={e =>
                                                                                            form.setFieldValue(
                                                                                                `order_details[${index}].${field.name}`,
                                                                                                /^[0-9]+$/.test(e.target.value)
                                                                                                    ? parseInt(e.target.value)
                                                                                                    : ''
                                                                                            )
                                                                                        }
                                                                                    />
                                                                                )}
                                                                            </Field>
                                                                        </SimpleTable.TD>
                                                                        <SimpleTable.TD>
                                                                            <div className="flex items-center justify-center gap-3 py-1">
                                                                                {values?.order_details.length - 1 === index && (
                                                                                    <Button
                                                                                        type="button"
                                                                                        className="text-white border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                                                                        onClick={() => {
                                                                                            const saveorder = clone(
                                                                                                values?.order_details ?? []
                                                                                            )
                                                                                            saveorder.push({
                                                                                                ...orderDefaultData,
                                                                                            })
                                                                                            setFieldValue(
                                                                                                'order_details',
                                                                                                saveorder
                                                                                            )
                                                                                        }}
                                                                                    >
                                                                                        <AiOutlinePlus size={20} />
                                                                                    </Button>
                                                                                )}
                                                                                <Button
                                                                                    type="button"
                                                                                    className="text-white border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                                                                    onClick={() => {
                                                                                        const saveorder = clone(
                                                                                            values?.order_details
                                                                                        )
                                                                                        remove(
                                                                                            saveorder,
                                                                                            (n, key) => key === index
                                                                                        )
                                                                                        setFieldValue('order_details', saveorder)
                                                                                    }}
                                                                                >
                                                                                    <AiOutlineClose size={20} />
                                                                                </Button>
                                                                            </div>
                                                                        </SimpleTable.TD>
                                                                    </SimpleTable.TR>
                                                                ))}
                                                            </tbody>
                                                        </SimpleTable>
                                                    ) : (
                                                        <div className="flex items-center gap-3 py-1">
                                                            <Button
                                                                type="button"
                                                                className="text-white border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                                                onClick={() => {
                                                                    const saveorder = clone(values?.order_details ?? [])
                                                                    console.log('saveorder:', saveorder)
                                                                    saveorder.push({ ...orderDefaultData })
                                                                    setFieldValue('order_details', saveorder)
                                                                }}
                                                            >
                                                                <AiOutlinePlus size={20} />
                                                            </Button>
                                                        </div>
                                                    )}
                                                </div>
                                            </Tabs.Panel>
                                            <Tabs.Panel>
                                                <div className="grid grid-cols-1 gap-x-4 gap-y-4 md:grid-cols-5">
                                                    <div>
                                                        <Field name="file1">
                                                            {({ field, form }) => (
                                                                <Upload
                                                                    onFilesSelected={files =>
                                                                        form.setFieldValue(field.name, files[0])
                                                                    }
                                                                />
                                                            )}
                                                        </Field>
                                                        {values?.file1 ? null : (
                                                            <div className="mt-4 text-[blue]">
                                                                {values?.hedi01 && (
                                                                    <a
                                                                        href={values?.hedi01 || '#'}
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <u>Document - 1</u>
                                                                    </a>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        <Field name="file2">
                                                            {({ field, form }) => (
                                                                <Upload
                                                                    onFilesSelected={files =>
                                                                        form.setFieldValue(field.name, files[0])
                                                                    }
                                                                />
                                                            )}
                                                        </Field>
                                                        {values?.file2 ? null : (
                                                            <div className="mt-4 text-[blue]">
                                                                {values?.hedi02 && (
                                                                    <a
                                                                        href={values?.hedi02 || '#'}
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <u>Document - 2</u>
                                                                    </a>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        <Field name="file3">
                                                            {({ field, form }) => (
                                                                <Upload
                                                                    onFilesSelected={files =>
                                                                        form.setFieldValue(field.name, files[0])
                                                                    }
                                                                />
                                                            )}
                                                        </Field>
                                                        {values?.file3 ? null : (
                                                            <div className="mt-4 text-[blue]">
                                                                {values?.hedi03 && (
                                                                    <a
                                                                        href={values?.hedi03 || '#'}
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <u>Document - 3</u>
                                                                    </a>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        <Field name="file4">
                                                            {({ field, form }) => (
                                                                <Upload
                                                                    onFilesSelected={files =>
                                                                        form.setFieldValue(field.name, files[0])
                                                                    }
                                                                />
                                                            )}
                                                        </Field>
                                                        {values?.file4 ? null : (
                                                            <div className="mt-4 text-[blue]">
                                                                {values?.hedi04 && (
                                                                    <a
                                                                        href={values?.hedi04 || '#'}
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <u>Document - 4</u>
                                                                    </a>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        <Field name="file5">
                                                            {({ field, form }) => (
                                                                <Upload
                                                                    onFilesSelected={files =>
                                                                        form.setFieldValue(field.name, files[0])
                                                                    }
                                                                />
                                                            )}
                                                        </Field>
                                                        {values?.file5 ? null : (
                                                            <div className="mt-4 text-[blue]">
                                                                {values?.hedi05 && (
                                                                    <a
                                                                        href={values?.hedi05 || '#'}
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <u>Document - 5</u>
                                                                    </a>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </Tabs.Panel>
                                        </Tabs.Panels>
                                    </Tabs.Group>
                                    {values?.error_message && (
                                        <div className="mt-6 px-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
                                            <h4 className="text-sm text-[red] font-medium text-blue-900 dark:text-blue-100">
                                                Error: {values?.error_message}
                                            </h4>
                                        </div>
                                    )}
                                    <div className="flex items-center justify-end gap-4 mt-3">
                                        <Button
                                            className="h-10 w-18 text-[#F05540] border border-[#F05540] dark:text-[#F05540] dark:border-[#F05540]"
                                            onClick={handleDiscard}
                                        >
                                            Discard
                                        </Button>
                                        <Button
                                            type="submit"
                                            className="flex items-center justify-center px-6 py-2 text-white transition border rounded-lg cursor-pointer hover:bg-opacity-90 border-[#F05540] bg-[#F05540] dark:border-[#F05540] dark:bg-[#F05540]"
                                        >
                                            Save
                                        </Button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Create
